function AirplaneIcon(){

    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
            <circle cx="19" cy="19" r="19" fill="#53ABF7"/>
            <path d="M30.0832 23.4332V21.2165L20.6623 15.6748V9.579C20.6623 8.65909 19.9198 7.9165 18.9998 7.9165C18.0799 7.9165 17.3373 8.65909 17.3373 9.579V15.6748L7.9165 21.2165V23.4332L17.3373 20.6623V26.7582L14.5665 28.4207V30.0832L18.9998 28.9748L23.4332 30.0832V28.4207L20.6623 26.7582V20.6623L30.0832 23.4332Z" fill="white"/>
        </svg>
        
    )



}
export default AirplaneIcon;